import React from 'react';
import { Sparkles } from 'lucide-react';
import { CustomFieldInput } from './custom-field-input';

// One step in the multi-step intake: a motivating headline + subtext above
// 1-3 questions. Fields are rendered with the shared CustomFieldInput so
// every step has consistent radio/checkbox styling.
export function QuestionStep({ headline, subtext, fields, formData, onChange }) {
  const setCustom = (id, value) =>
    onChange({ ...formData, custom_data: { ...formData.custom_data, [id]: value } });

  const setOtherText = (key, value) =>
    onChange({ ...formData, custom_data: { ...formData.custom_data, [key]: value } });

  return (
    <div className="space-y-3 animate-fade-in">
      {(headline || subtext) && (
        <div className="rounded-lg border border-primary/30 bg-primary-soft/60 p-3">
          <div className="flex items-start gap-2.5">
            <div className="mt-0.5 flex size-6 shrink-0 items-center justify-center rounded-md bg-primary text-primary-foreground">
              <Sparkles className="size-3" />
            </div>
            <div className="space-y-0.5">
              {headline && <h4 className="text-sm font-semibold leading-tight text-foreground">{headline}</h4>}
              {subtext && <p className="text-xs leading-relaxed text-muted-foreground">{subtext}</p>}
            </div>
          </div>
        </div>
      )}

      <div className="space-y-3">
        {fields.map((field) => (
          <CustomFieldInput
            key={field.id}
            field={field}
            value={formData.custom_data?.[field.id]}
            otherTexts={formData.custom_data}
            onChange={setCustom}
            onOtherChange={setOtherText}
          />
        ))}
      </div>
    </div>
  );
}
